module.exports = "/images/philippine-daily-inquirer.png?ebf217e96452f2e7ce87cef3d4aa11c2";